import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SEOHead from "@/components/SEOHead";
import { useTranslation } from "react-i18next";
import { lazy, Suspense } from "react";
import { useLanguage } from "@/hooks/useLanguage";

// Lazy load below-the-fold components
const Features = lazy(() => import("@/components/Features"));
const Services = lazy(() => import("@/components/Services"));
const About = lazy(() => import("@/components/About"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));

// Skeleton loader for lazy components
const SectionSkeleton = () => (
  <div className="min-h-[400px] animate-pulse bg-muted/20" />
);

const Index = () => {
  const { t } = useTranslation();
  const { currentLang } = useLanguage();
  const canonical = currentLang === "cs"
    ? "https://ekokompakt.cz/"
    : `https://ekokompakt.cz/${currentLang}`;

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={`${t("hero.title1")} ${t("hero.titleHighlight")} ${t("hero.title2")} | EkoKompakt`}
        description={t("hero.subtitle")}
        canonical={canonical}
        ogImage="https://ekokompakt.cz/og-image.png"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "EkoKompakt",
            "url": "https://ekokompakt.cz",
            "description": t("hero.subtitle"),
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "EkoKompakt, s. r. o.",
            "url": "https://ekokompakt.cz",
            "logo": "https://ekokompakt.cz/logo.png",
            "description": t("hero.subtitle"),
            "telephone": "+420724301099",
            "email": "info@ekokompakt.cz",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Poznaňská 7",
              "addressLocality": "Brno",
              "postalCode": "616 00",
              "addressCountry": "CZ"
            },
            "vatID": "CZ08062684",
            "taxID": "08062684",
            "areaServed": ["CZ", "SK", "DE", "AT", "PL", "HU", "HR", "IT", "NL", "EE", "LV", "LT"],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+420724301099",
              "contactType": "customer service",
              "email": "info@ekokompakt.cz",
              "availableLanguage": ["cs", "en", "de", "sk"]
            }
          }
        ]}
      />
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<SectionSkeleton />}>
          <Features />
          <Services />
          <About />
          <CTA />
        </Suspense>
      </main>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
